import gql from "graphql-tag";

export const MY_CAFETERIA_MY_TIME_GET_PERIODS = gql`
  query getCafeteriaPeriods {
    getCafeteriaPeriods {
      contractCode
      periodStartDate
      periodEndDate
    }
  }
`;

export default MY_CAFETERIA_MY_TIME_GET_PERIODS;
